(() => {
	const initSliders = () => {
		const slideshows = document.querySelectorAll(".slideshow__swiper");
		slideshows.forEach((slideshow) => {
			const autoplay =
				slideshow.getAttribute("data-autoplay") === "true" ? true : false;
			const showProgress =
				slideshow.getAttribute("data-show-progress") === "true";
			const slideDurationAttr = parseFloat(
				slideshow.getAttribute("data-slide-duration")
			);
			const slideDuration =
				!isNaN(slideDurationAttr) && slideDurationAttr > 0
					? slideDurationAttr * 1000
					: 5000;
			const progressBar = slideshow.querySelector(".slideshow__progress-bar");

			const resetProgress = () => {
				if (!progressBar) return;
				progressBar.style.transition = "none";
				progressBar.style.width = "0%";
				
				void progressBar.offsetWidth;
			};

			const startProgress = (duration) => {
				if (!progressBar) return;
				resetProgress();
				progressBar.style.transition = `width ${duration}ms linear`;
				progressBar.style.width = "100%";
			};

			const pauseProgress = () => {
				if (!progressBar) return;
				const computed = window.getComputedStyle(progressBar).width;
				progressBar.style.transition = "none";
				progressBar.style.width = computed;
			};

			const slideshowSwiper = new Swiper(slideshow, {
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				loop: true,
				autoHeight: false,
				allowTouchMove: true,
			});

			if (autoplay) {
				slideshowSwiper.autoplay.run();
				slideshowSwiper.autoplay.running = true;

				if (showProgress && progressBar) {
					startProgress(slideDuration);

					slideshowSwiper.on("slideChangeTransitionStart", () => {
						startProgress(slideDuration);
					});
				}

				slideshow.addEventListener("mouseenter", () => {
					slideshowSwiper.autoplay.pause();
					if (showProgress) pauseProgress();
				});
				slideshow.addEventListener("mouseleave", () => {
					slideshowSwiper.autoplay.run();
					if (showProgress && progressBar) {
					
						const barWidth = progressBar.getBoundingClientRect().width;
						const trackWidth =
							progressBar.parentElement.getBoundingClientRect().width;
						const progressRatio = trackWidth > 0 ? barWidth / trackWidth : 0;
						const remaining = Math.max(
							slideDuration * (1 - progressRatio),
							0
						);
						progressBar.style.transition = `width ${remaining}ms linear`;
						progressBar.style.width = "100%";
					}
				});
			}
			if (slideshowSwiper.addSlide.length < 2) {
				slideshowSwiper.allowTouchMove = false;
			} else {
				slideshowSwiper.allowTouchMove = true;
			}
			if (slideshowSwiper.addSlide.length > 1)
				slideshow.classList.add("slideshow__swiper--multiple-slides");
		});
	};

	initSliders();

	document.addEventListener("shopify:section:load", function () {
		initSliders();
	});
})();
